import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  Error(message: string, options = { timeout: 3000 }): Observable<never> {
    this.snackbar.error(message, options);
    return EMPTY;
  }

  Success(message: string, options = { timeout: 3000 }): void {
    this.snackbar.success(message, options);
  }

  // Hide() {
  //     console.log('before', this.snackbar.innerHTML);
  //     this.snackbar.innerHTML = '';
  //     console.log('after', this.snackbar.innerHTML);
  // }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get snackbar(): any {
    return this.document.querySelector('ds-snack-bar');
    // this.document.querySelector('ds-snack-bar') ||
    // (({ success: () => {} } as unknown) as HTMLDsSnackBarElement)
  }
}
